import styled from "styled-components";

export const PaymentSection = styled.section`
    text-align: center;
`